import { render } from "./ActivityLiveBoard.vue?vue&type=template&id=ee3e3ef0&scoped=true"
import script from "./ActivityLiveBoard.vue?vue&type=script&lang=js"
export * from "./ActivityLiveBoard.vue?vue&type=script&lang=js"

import "./ActivityLiveBoard.vue?vue&type=style&index=0&id=ee3e3ef0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3e3ef0"]])

export default __exports__